import Payments from "./components/Payments";

export default Payments;
